export default {
  HYBRID_PRICE: 2795, // https://www.homedepot.ca/product/rheem-proterra-50-gallon-189l-10-year-4-5kw-hybrid-high-efficiency-tank-electric-water-heater/1001586346
  HYBRID_INSTALLATION_PRICE: 1500,
  MAX_HYBRID_PRICE: 3500,
  MAX_HYBRID_INSTALLATION_PRICE: 1500,
  ELECTRIC_PRICE: 1499, // https://www.homedepot.ca/product/rheem-marathon-50-gallon-189l-lifetime-electric-water-heater-4-5kw-240v-/1001070393
  ELECTRIC_INSTALLATION_PRICE: 1500,
  ELECTRIC_ANNUAL_KILOWATTS: 3492,
  HYBRID_ANNUAL_KILOWATTS: 837,
  ZIP_CODE_LENGTH: 3,
  HYBRID_MODEL_FOR_API_REQUEST: 'XE50T06ST45U1',
  API_FOR_REBATE_PROGRAMS: 'https://rheem.ecorebates.com/api/search/rheem/categoryRebateDetails.json?c=CA&filter_product_type=waterheater&filter_rebate_consumer_type=residential',
  API_FOR_STATE_BY_ZIP: 'https://api.zippopotam.us/ca',
  MAIN_COLOR: '#e70033',
  IMG_DIR: '/wp-content/themes/RheemTheme/hybrid-saving-calculator/dist-canada/img',
  AVERAGE_RATE: 0.179,
  RATES: [
    { state: 'Alberta', rate: 0.258 },
    { state: 'British Columbia', rate: 0.144 },
    { state: 'Manitoba', rate: 0.102 },
    { state: 'New Brunswick', rate: 0.139 },
    { state: 'Newfoundland & Labrador', rate: 0.148 },
    { state: 'Nova Scotia', rate: 0.183 },
    { state: 'Northwest Territories', rate: 0.41 },
    { state: 'Nunavut', rate: 0.354 },
    { state: 'Ontario', rate: 0.141 },
    { state: 'Prince Edward Island', rate: 0.184 },
    { state: 'Quebec', rate: 0.078 },
    { state: 'Saskatchewan', rate: 0.199 },
    { state: 'Yukon Territory', rate: 0.187 },
  ],
  GET_REBATE_PROGRAMS: (rebateResponse) => {
    const productRebateDetails = rebateResponse.categoryRebateDetails;
    return productRebateDetails.length > 0
      ? productRebateDetails[0].rebatePrograms
        .map((item) => {
          let value = 0;
          let enabled = false;
          if (item.purchaseRebate.units === 'USD') {
            value = item.purchaseRebate.amount;
          } else if (item.purchaseRebate.units === 'PCT_OFF_SALE_PRICE') {
            const regexpRes = item.amountLabel.match(/up\sto\s\$(.*)\)/);
            if (regexpRes && regexpRes[1]) {
              value = +regexpRes[1].replace(',', '');
            }
          }
          if (!Number.isNaN(value) && value > 0) {
            enabled = true;
          }
          return {
            ...item,
            value,
            enabled,
            checked: false,
          };
        }) : [];
  },
  STEPS: [
    { id: 1, label: '1. Price & Rate' },
    { id: 2, label: '2. Rebates & Incentives' },
    { id: 3, label: '3. Return on investment' },
  ],
  ROI_BACKGROUND_IMAGE: 'ROI-background.jpg',
  SHOW_KWIKCOMFORT_BLOCK: true,
  FULL_LEGAL_DISCLAIMER: true,
};
